import React, { useState } from 'react';
import { Layout, Card } from 'antd';
import PageTitle from 'shared_components/page_title';
import SearchPager from 'shared_components/search_pager';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';

import SearchReportForm from './searchReportForm';
// import SearchReportTable from './searchReportTable';

import './reports.css';

const { Content } = Layout;

function SearchAccountingReport() {
	const [data, setData] = useState([]);
	const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE);
	// const [generatedFiles, setGeneratedFiles] = useState([]);

	function search(payload) {
		setData(payload);
	}

	const handleChangeSize = pageSize => {
		setPageSize(pageSize);
	};

	// function searchGeneratedFiles(payload){
	// 	setGeneratedFiles(payload);
	// }

	return (
		<div>
			<Card>
				<PageTitle pageTitle="ACCOUNTING REPORTS" />
				<Content>
					<SearchReportForm onFinish={search} />
					{/* <SearchReportTable data={generatedFiles} pageSize={pageSize} /> */}
				</Content>
			</Card>
		</div>
	);
}

export default SearchAccountingReport;
